<template>
  <div>
    <a-card
      :bordered="false"
      class="header-solid h-full mb-20"
      :bodyStyle="{ paddingTop: '20px' }"
    >
      <template #title>
        <h6><a @click="goToMainPage" class="mr-5"><a-icon type="arrow-left" /></a>Vehicle Form</h6>
        <p class="mt-0 mb-0">
          In case of booking a car after working hours, the admin will arrange
          the car within working hours of the following day (9:00 - 16:00).
        </p>
        <p class="mt-0 mb-0">
          For urgent matter, please contact 02-700-5000 Ext.1101 or call
          064-9251438
        </p>
      </template>
      <a-form :layout="'horizontal'">
        <a-form-item
          label="Email"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 12 }"
          extra="If you want to reserve a car on behalf of someone elfe, you can use an email of ..."
        >
          <a-input v-model="formVehicle.email" placeholder="enter email ..." />
        </a-form-item>
        <a-form-item
          label="Category"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-select
            show-search
            placeholder="select reason type ..."
            option-filter-prop="children"
            v-model="formVehicle.reason"
          >
            <a-select-option
              v-for="(item, index) in optionReson"
              :key="'reason' + index"
              :value="item.value"
            >
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="Destination"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 12 }"
          extra="It should include, for example: address, Amphur, Province.*"
        >
          <a-input
            v-model="formVehicle.Destination"
            placeholder="enter destination ..."
          />
        </a-form-item>
        <a-form-item
          label="Number of passengers"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 12 }"
          extra="Note that it can have negative integer and zero!"
        >
          
          <a-input-number style="width: 100%;" id="inputNumber" v-model="formVehicle.passenger" :min="1" placeholder="enter number of passengers ..." />
        </a-form-item>
        <a-form-item
          label="Remark: (if any)"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 12 }"
          extra=""
        >
          <a-textarea
            placeholder=""
            :auto-size="{ minRows: 3, maxRows: 5 }"
            v-model="formVehicle.Remark"
          />
        </a-form-item>
        <!-- Use start -->
        <a-form-item
          label="Use start"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 12 }"
          extra=""
        >
          <a-date-picker class="mr-10" v-model="formVehicle.dayStart" />
          <a-time-picker format="HH:mm" v-model="formVehicle.timeStart" />
        </a-form-item>
        <!-- Use end -->
        <a-form-item
          label="Use end"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 12 }"
          extra=""
        >
          <a-date-picker class="mr-10" v-model="formVehicle.dayEnd" :disabled-date="disabledDate" />
          <a-time-picker format="HH:mm" v-model="formVehicle.timeEnd" />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 20, offset: 4 }">
          <a-button
            type="primary"
            :disabled="!isFormVehicle || !isTimeBooking"
            @click="visible = true"
            class="mr-10"
          >
            Submit
          </a-button>
          <a-button type="danger" @click="clearForm"> Cancel </a-button>
        </a-form-item>
      </a-form>
    </a-card>
    <a-modal
      title="Confirm"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="submitFormBookCar"
      @cancel="visible = false"
    >
      <p>Are you sure to Submit ?</p>
    </a-modal>
  </div>
</template>

<script>
import authService from '../../../services/authService';

const form = {
  email: "",
  reason: "",
  passenger: 1,
  Destination: "",
  Remark: "",
  dayStart: "",
  timeStart: "",
  dayEnd: "",
  timeEnd: "",
};
export default {
  data() {
    return {
      formVehicle: Object.assign({}, form),
      optionReson: [],
      loadBtnSubmit: false,
      errorSubmit: "",
      visible: false,
      confirmLoading: false,
    };
  },
  computed: {
    isFormVehicle() {
      if (
        this.formVehicle.email !== "" &&
        this.formVehicle.passenger !== "" &&
        this.formVehicle.reason !== "" &&
        this.formVehicle.Destination !== "" &&
        this.formVehicle.dayStart !== "" &&
        this.formVehicle.timeStart !== "" &&
        this.formVehicle.dayEnd !== "" &&
        this.formVehicle.timeEnd !== ""
      ) {
        return true;
      } else {
        return false;
      }
    },
    isTimeBooking() {
      if (
        this.formVehicle.timeStart !== "" &&
        this.formVehicle.timeEnd !== ""
      ) {
        let start = `${this.moment(this.formVehicle.dayStart).format(
          "DD/MM/YYYY"
        )} ${this.moment(this.formVehicle.timeStart, "HH:mm:ss").format(
          "HH:mm:ss"
        )}`;
        let end = `${this.moment(this.formVehicle.dayEnd).format(
          "DD/MM/YYYY"
        )} ${this.moment(this.formVehicle.timeEnd, "HH:mm:ss").format(
          "HH:mm:ss"
        )}`;
        let ms = this.moment(start, "DD/MM/YYYY HH:mm:ss").diff(
          this.moment(end, "DD/MM/YYYY HH:mm:ss")
        );
        if (ms > 0) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
  },
  mounted() {
    // Priority 1: Keycloak email
    if (this.$keycloak && this.$keycloak.authenticated && this.$keycloak.tokenParsed) {
      this.formVehicle.email = this.$keycloak.tokenParsed.email;
    } else {
      // Priority 2: MSAL email
      const msalAccount = authService.getAccount();
      if (msalAccount) {
        this.formVehicle.email = msalAccount.username || '';
      }
    }
    this.getResonList();
  },
  methods: {
    goToMainPage() {
      this.$router
        .push({
          path: "/booking/vehicle",
        })
        .catch((err) => {});
    },
    disabledDate(endDate) {
      return this.moment(endDate).format("YYYY-MM-DD") < this.moment(this.formVehicle.dayStart).format("YYYY-MM-DD");
    },
    async getResonList() {
      this.optionReson = [];
      try {
        const res = await this.$http.get(`/vehicle/reason/`);
        if (res.status === 200) {
          this.optionReson = res.data.map((item) => {
            return {
              value: item.id,
              text: `${item.eng_detail}`,
            };
          });
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {}
    },
    clearForm() {
      this.formVehicle = Object.assign({}, form);
      // Priority 1: Keycloak email
      if (this.$keycloak && this.$keycloak.authenticated && this.$keycloak.tokenParsed) {
        this.formVehicle.email = this.$keycloak.tokenParsed.email;
      } else {
        // Priority 2: MSAL email
        const msalAccount = authService.getAccount();
        if (msalAccount) {
          this.formVehicle.email = msalAccount.username || '';
        }
      }
      this.$router
        .push({
          path: "/booking/vehicle",
        })
        .catch((err) => {});
    },
    async submitFormBookCar() {
      this.loadBtnSubmit = true;
      this.errorSubmit = null;
      const sendData = new FormData();
      sendData.append("email", this.formVehicle.email);
      sendData.append("destination", this.formVehicle.Destination);
      sendData.append("reason", this.formVehicle.reason);
      sendData.append("passenger", this.formVehicle.passenger);
      sendData.append(
        "use_start",
        this.moment(this.formVehicle.dayStart).format("YYYY-MM-DD") +
          "T" +
          this.moment(this.formVehicle.timeStart, "HH:mm:ss").format(
            "HH:mm:ss"
          ) +
          "+07:00"
      );
      sendData.append(
        "use_end",
        this.moment(this.formVehicle.dayEnd).format("YYYY-MM-DD") +
          "T" +
          this.moment(this.formVehicle.timeEnd, "HH:mm:ss").format("HH:mm:ss") +
          "+07:00"
      );
      if (this.formVehicle.Remark !== "" || this.formVehicle.Remark !== null) {
        sendData.append("remark", this.formVehicle.Remark);
      } else {
        sendData.append("remark", "-");
      }
      try {
        const response = await this.$http.post("/vehicle/booking/", sendData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (response.status === 201) {
          this.clearForm();
          this.visible = false;
        } else {
          const error = new Error('Request Failed');
          error.response = response;
          throw error;
        }
      } catch (error) {
        this.loadBtnSubmit = false;
        this.errorSubmit = error;
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${error.response.status}`),
            ]);
          },
          description: `Problem issue connect api : /vehicle/booking/`,
        });
      }
    },
  },
};
</script>